import { useState, type ReactNode } from "react";

// Hand-rolled tooltip — avoids pulling in a popup library for ~12 labels.
// Renders inline-block so it wraps whatever content the caller passes
// (header text, KV label, badge). The popup is absolutely positioned above
// the trigger with an arrow, pointer-events:none so it never intercepts
// clicks on parent elements (matters for the sortable Leaderboard headers).
export function HelpTooltip({
  text,
  children,
  width = 280,
}: {
  text: string;
  children: ReactNode;
  width?: number;
}) {
  const [open, setOpen] = useState(false);
  return (
    <span
      style={{ position: "relative", display: "inline-block", cursor: "help" }}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onFocus={() => setOpen(true)}
      onBlur={() => setOpen(false)}
    >
      {children}
      {open && (
        <span
          role="tooltip"
          style={{
            position: "absolute",
            bottom: "calc(100% + 8px)",
            left: "50%",
            transform: "translateX(-50%)",
            width,
            background: "#0f172a",
            border: "1px solid #334155",
            color: "#e2e8f0",
            padding: "8px 10px",
            borderRadius: 6,
            fontSize: 12,
            lineHeight: 1.45,
            textAlign: "left",
            whiteSpace: "normal",
            zIndex: 100,
            pointerEvents: "none",
            boxShadow: "0 4px 12px rgba(0,0,0,0.5)",
          }}
        >
          {text}
          <span
            style={{
              position: "absolute",
              top: "100%",
              left: "50%",
              transform: "translateX(-50%)",
              width: 0,
              height: 0,
              borderLeft: "6px solid transparent",
              borderRight: "6px solid transparent",
              borderTop: "6px solid #334155",
            }}
          />
        </span>
      )}
    </span>
  );
}
